import styled from 'foundations-theming/utils';
const InProgressDot = styled.div.withConfig({
  displayName: "ACInProgressDot__InProgressDot",
  componentId: "sc-1ikcc1a-0"
})(["margin-right:6px;background-color:", ";height:6px;width:6px;border-radius:50%;display:inline-block;position:relative;bottom:1px;"], ({
  theme
}) => theme.color['fill-accent-orange-default']);
export default InProgressDot;